import { $sxhr } from "../../stempcore";
import { sxhr } from "fire-wind-water/sxhr";
import { from, of } from "rxjs";
import { mergeMap } from "rxjs/operators";
// import URL from "../assets/conf/setting.json";
// import $ from "jquery";

const cacheWithParams = {
  _cache_with_cached: 0,
  _cache_refresh: 0,
  _cache_timeout: 5 * 60
};

const staticRequest = function(url, info, conf) {
  // 存在静态化配置，优先获取静态连接，如不存在，走API请求
  var staticUrl = window.staticReqMapping
    ? window.staticReqMapping.getStaticUrl(url, info)
    : "";
  // console.log('########################################');
  // console.log(url, staticUrl);
  const params = { ...info, ...cacheWithParams };
  if (staticUrl) {
    return from(
      // 利用from操作符将Promise转为Observable
      // 请求静态地址(url上需要添加随机数，以保证数据为最新)
      sxhr
        .get(staticUrl + "?time_stamp=" + new Date().getTime(), info, conf)
        .then(
          res => {
            return res.data.body;
          },
          () => {
            return null; // 静态json错误，返回null
          }
        )
    ).pipe(
      mergeMap(body => {
        if (body) {
          return of(body);
        } else {
          // 静态json出错，转为API请求
          return $sxhr.post(url, params, conf);
        }
      })
    );
  } else {
    return $sxhr.post(url, params, conf);
  }
};

export default {
  //获取会议信息
  getArticle: info => {
    return staticRequest("article/getDetail", info);
  }, //获取文件列表
  getCommentList: info => {
    return $sxhr.post("comment/getList", info);
  },
  getFileList: info => {
    return $sxhr.post("file/getListForWeChat", info);
  },
  getLikeStatus: info => {
    return staticRequest("article/getLikeStatus", info);
  },
  like: info => {
    return $sxhr.post("article/like", info);
  },
  deleteComment: info => {
    return $sxhr.post("comment/front/delete", info);
  },
  commentLike: info => {
    return $sxhr.post("comment/like", info);
  },
  getNewForm: info => {
    return staticRequest("member/form/GetForNewForm", info);
  },
  createComment: info => {
    return $sxhr.post("comment/create", info);
  },
  downloadWithEmail: info => {
    return $sxhr.post("file/downloadWithEmail", info);
  },
  browse: info => {
    return $sxhr.post("article/browse", info);
  },
  getSubList: info => {
    return staticRequest("articleCategory/getSubList", info);
  },
  getArticleList: info => {
    return staticRequest("article/getListByProject", info);
  },
  browseCategory: info => {
    return $sxhr.post("api/article/category/interaction/browse", info);
  },
  getConfig: info => {
    return staticRequest("template/template/getConfig", info);
  }
};
